import { stammdatenService } from './StammdatenService.js';
import { zeigeKleineNachricht } from '../systemNachricht.js';

/**
 * Frontend-Service für Tagesvorlagen (Bedarfsplaner) — siehe reference/tagesvorlagen/TAGESVORLAGEN.md.
 */
class TagesvorlageService {
	/**
	 * Holt alle Tagesvorlagen der aktuellen Betriebsstätte (nach Name sortiert).
	 * @returns {Promise<array<object>>}
	 */
	async holeTagesvorlagen() {
		try {
			const response = await fetch(`/dienstplan/api/tagesvorlagen?BetriebsstaetteID=${stammdatenService.aktuelleBetriebsstaette}`);
			if (!response.ok) {
				const message = await response.text();
				zeigeKleineNachricht(message, 0);
				return [];
			}
			return await response.json();
		} catch (error) {
			console.log(error);
			return [];
		}
	}

	/**
	 * Speichert eine Tagesvorlage. Neu (kein _id) → POST, sonst PUT.
	 * @param {object} vorlage
	 * @returns {Promise<object|false>} die gespeicherte Vorlage
	 */
	async speichereTagesvorlage(vorlage) {
		try {
			const istNeu = !vorlage._id;
			const url = istNeu ? '/dienstplan/api/tagesvorlagen' : `/dienstplan/api/tagesvorlagen/${vorlage._id}`;
			const response = await fetch(url, {
				method: istNeu ? 'POST' : 'PUT',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ ...vorlage, BetriebsstaetteID: stammdatenService.aktuelleBetriebsstaette }),
			});
			if (!response.ok) {
				const message = await response.text();
				zeigeKleineNachricht(message, 0);
				return false;
			}
			zeigeKleineNachricht('Tagesvorlage gespeichert!', 1);
			return await response.json();
		} catch (error) {
			console.log(error);
			zeigeKleineNachricht('Speichern fehlgeschlagen!', -1);
			return false;
		}
	}

	/**
	 * Setzt Tagesvorlagen als Bedarf ein (immer ergänzend).
	 * @param {array<{Datum: string, TagesvorlageIDs: array<string>}>} einsaetze Datum als YYYY-MM-DD
	 * @returns {Promise<{angelegt: number, uebersprungen: array}|false>}
	 */
	async setzeVorlagenEin(einsaetze) {
		try {
			const response = await fetch('/dienstplan/api/tagesvorlagen/einsetzen', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ BetriebsstaetteID: stammdatenService.aktuelleBetriebsstaette, Einsaetze: einsaetze }),
			});
			if (!response.ok) {
				const message = await response.text();
				zeigeKleineNachricht(message, 0);
				return false;
			}
			return await response.json();
		} catch (error) {
			console.log(error);
			zeigeKleineNachricht('Einsetzen fehlgeschlagen!', -1);
			return false;
		}
	}

	/**
	 * @param {string} vorlageID
	 * @returns {Promise<boolean>}
	 */
	async entferneTagesvorlage(vorlageID) {
		try {
			const response = await fetch(`/dienstplan/api/tagesvorlagen/${vorlageID}`, { method: 'DELETE' });
			if (!response.ok) {
				const message = await response.text();
				zeigeKleineNachricht(message, 0);
				return false;
			}
			zeigeKleineNachricht('Tagesvorlage gelöscht!', 1);
			return true;
		} catch (error) {
			console.log(error);
			zeigeKleineNachricht('Löschen fehlgeschlagen!', -1);
			return false;
		}
	}
}

const tagesvorlageService = new TagesvorlageService();
export { tagesvorlageService };
